
import React from 'react';
const SingleUserPage = () => {
  return (
    <div>

    </div>
  )
}

export default SingleUserPage;
